// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { assetsManifest } from './assets';
import { contractsManifest } from './contracts';
import { correspondenceManifest } from './correspondence';
import { hrRequestsManifest } from './hr-requests';
import { mpFinanceManifest } from './mp-finance';
import { procurementManifest } from './procurement';
import { travelRequestsManifest } from './travel-requests';

/** Група модулів «Офіс» (Office): 7 модулів. */
export const officeGroup: IModuleGroupManifest = {
  key: 'office',
  category: 'Office',
  name: { en: 'Office', uk: 'Офіс' },
  sort: 19,
  modules: [assetsManifest, contractsManifest, correspondenceManifest, hrRequestsManifest, mpFinanceManifest, procurementManifest, travelRequestsManifest],
};
